module.exports = __webpack_public_path__ + "static/media/tshirt.63b0abe2.png";